import { Injectable } from '@angular/core';
import { notNull } from '@app/shared/utils';
import { isEqual } from 'lodash';
import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportFilterService {
  public filterType$: Observable<any>;
  private _filterType$ = new BehaviorSubject<any>(undefined);

  constructor() {
    this.filterType$ = this._filterType$.asObservable().pipe(notNull(), distinctUntilChanged(isEqual));
  }

  public passfilterType(filterType: any) {
    this._filterType$.next(filterType);
  }
}
